import React from 'react'
import { Control } from 'react-redux-form'
import TextField from '@material-ui/core/TextField';

class MyTextField extends React.PureComponent {
  render() {
    const {FormHelperTextProps, className, children, ...props} = this.props
    const errorClass = this.props.error ? 'InputWithErrors' : 'InputFocusLabel'
    const newClassName = `${className} ${errorClass}`

    return (
      <TextField
        FormHelperTextProps={{
          classes: {
            root: 'TextInputHelperText',
            error: 'TextInput-error'
          }
        }}
        InputProps={{
          ...this.props.InputProps,
          classes: {
            error: 'TextInputContainer-error'
          }
        }}
        className={newClassName}
        {...props}
      >{children}</TextField>
    )
  }
}

class TextInput extends React.PureComponent {
  render() {
    const {nocontrol, className, ...props} = this.props
    if ( nocontrol === true ) {
      return (
        <MyTextField
          className={className ? className : "w-100"}
          margin="normal"
          {...props}
        />
      )
    }

    return (
      <Control
        component={MyTextField}
        className={className ? className : "w-100"}
        margin="normal"
        {...props}
      />
    )
  }
}

export default TextInput



// WEBPACK FOOTER //
// ./src/js/components/inputs/TextInput.js